<div *ngIf="refreshOverlayService.isFullScreenOverlayVisible" class="overlay" (click)="onOverlayClick()">
  <p>{{refreshOverlayService.placeholderText}}</p>
</div>